<template>
  <div id="dialog" class="dialog-size">
    <table id="table-layout" border="0">
      <tr>
        <td id="table-td-title">
        <h><!--Engage for Members by eHealth Engagement LLC.-->
        {{ $t('messageBox.header') }}
        </h>
        </td>
      </tr>
      <tr>
        <td id="table-td-icon">
          <img src="../../../assets/images/Information-icon.png" width="50px" style="vertical-align:middle">
          <!--Information.-->
          {{ $t('messageBox.information') }}
        </td>
      <tr>
      <tr>
        <td id="table-td-message">
          <!--<p>{{ this.text }}</p>-->
  
          <textarea style="text-align:center;background-color:#F0F0F0;textmax-height:70px;min-height:70px;width:100%;resize:none;padding-left:5px;padding-right:5px;border:none;"
            v-model="this.text">
          </textarea>
        </td>
      </tr>
      <tr>
        <td id="table-td-command">
          <input type="button" id="command" v-on:click.capture="end()" v-bind:value="$t('messageBox.close')">
        </td>
      </tr>
      
    </table>
  </div>   
</template>

<script>
  
  export default {
      name: 'message-box',
      props: ['text', 'func'],
      methods:
      {
        end()
        { 
          this.$emit('close');
         
          if(this.func != undefined)
          { 
            // EXTERNAL FUCTION POINTER
            this.func();
          }
        }
      }
  }
  
</script>
<style lang="scss" scoped>

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  div.dialog-size {
    margin: auto;
    width:100%;
    height:100%;
  }
  #table-layout
  {
    width:100%;
    height:100%;
  }
  #table-td-title
  {
    color:white;
    text-align:center;
    background-color: #343F68;
  }
  #table-td-icon
  {
    color:black;
    display: inline-block;
    padding-left: 10px;
    vertical-align:middle;
    border-bottom:1px solid black;
    width: 100%;
    background-color: #F0F0F0;//#4682B4;
    padding-top:5px;
    padding-bottom: 5px;
    font-weight: 500;
  }
  #table-td-message
  {
    color:black;
    height: 100%;
    vertical-align:top;
    text-align:center;
    background-color: #F0F0F0;//#4682B4;
    padding-top: 10px;
  }
  #table-td-command
  {
    color:black;
    vertical-align:bottom;
    text-align:center;
    background-color: #F0F0F0;//#4682B4;
    padding-bottom: 10px;
  }
  #command
  {
    border-radius:15px;
    background-color:#343F68;
    color:white;
    font-size: 15px;
  }
}
//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  div.dialog-size {
    margin: auto;
    width:100%;
    height:100%;
  }
  #table-layout
  {
    width:100%;
    height:100%;
  }
  #table-td-title
  {
    color:white;
    text-align:center;
    background-color: #343F68;
  }
  #table-td-icon
  {
    color:black;
    display: inline-block;
    padding-left: 10px;
    vertical-align:middle;
    border-bottom:1px solid black;
    width: 100%;
    background-color: #F0F0F0;//#4682B4;
    padding-top:5px;
    padding-bottom: 5px;
    font-weight: 500;
  }
  #table-td-message 
  {
    color:black;
    height: 100%;
    vertical-align:top;
    text-align:center;
    background-color: #F0F0F0;//#4682B4;
    padding-top: 10px;
  }
  #table-td-command
  {
    color:black;
    vertical-align:bottom;
    text-align:center;
    background-color: #F0F0F0;//#4682B4;
    padding-bottom: 10px;
  }
  #command
  {
    border-radius:15px;
    background-color:#343F68;
    color:white;
    font-size: 15px;
  }
}
</style>